import React from "react";
import { TextField, InputAdornment, Typography, SxProps, Theme } from "@mui/material";

interface GeneralInputProps {
  label?: string;
  placeholder: string;
  name: string;
  type?: string;
  value?: string | number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string;
  startAdornmentLabel?: string;
  maxWidth?: string;
  showLabel?: boolean;
  sxProps?: SxProps<Theme>;
  min?: number;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const InputGrayStart: React.FC<GeneralInputProps> = ({
  label,
  placeholder,
  name,
  type = "text",
  value,
  onChange,
  error = false,
  helperText,
  startAdornmentLabel,
  maxWidth = "260px",
  showLabel = true,
  sxProps = {},
  min,
  onKeyDown,
}) => {
  return (
    <>
      {showLabel && label && (
        <Typography variant="subtitle1" sx={{ mt: 2 }}>
          {label}
        </Typography>
      )}
      <TextField
        placeholder={placeholder}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        error={error}
        helperText={helperText}
        inputProps={{ min }}
        onKeyDown={onKeyDown}
        sx={{
          maxWidth,
          pt: 1,
          "& .MuiOutlinedInput-root": {
            padding: 0,
          },
          "& .MuiFormHelperText-root, .MuiFormHelperText-root.Mui-error": {
            color: "#fd7b7c",
          },
          ...sxProps,
        }}
        InputProps={{
          startAdornment: startAdornmentLabel && (
            <InputAdornment
              position="start"
              sx={{
                width: "90px",
                bgcolor: "rgba(0,0,0,0.05)",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                maxHeight: "100%",
                borderRadius: "8px 0 0 8px",
              }}
            >
              {startAdornmentLabel}
            </InputAdornment>
          ),
        }}
      />
    </>
  );
};

export default InputGrayStart;
